import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import jssVariables from "../../jss_setup";

export const trainPax = {
  youths: {
    from: 0,
    to: 29,
  },
  adults: {
    from: 30,
    to: 59,
  },
  seniors: {
    from: 60,
    to: 101,
  },
};

const buttonStyles = createUseStyles({
  button: {
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
    padding: "10px 20px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
      transform: "translateY(-2px)",
    },
  },
  primary: {
    backgroundColor: jssVariables.colors.base_color,
    color: "#fff",
  },
  secondary: {
    backgroundColor: "#f8f9fa",
    color: "#212529",
  },
  large: {
    fontSize: "16px",
    padding: "15px 30px",
  },
  small: {
    fontSize: "12px",
    padding: "5px 10px",
  },
});
const Button = ({ children, size, variant, onClick }) => {
  const classes = buttonStyles();

  return (
    <button
      className={`${classes.button} ${classes[variant]} ${classes[size]}`}
      onClick={onClick}>
      {children}
    </button>
  );
};
Button.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["primary", "secondary"]),
  onClick: PropTypes.func,
};
Button.defaultProps = {
  size: "medium",
  variant: "primary",
};

const contactModalStyles = createUseStyles({
  overlay: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(5px)",
    zIndex: "9999",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  FlightContactModal: {
    backgroundColor: "#fff",
    borderRadius: "5px",
    padding: "20px",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    gridTemplateColumns: "1fr",
    gridGap: jssVariables.normal_gap,
    textAlign: "center",
    width: "30%",
    justifyItems: "center",
    "@media (max-width: 768px)": { width: "80%" },
  },
  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  message: {
    fontSize: "16px",
    marginBottom: "20px",
  },
  button: {
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    padding: "10px 20px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#0069d9",
    },
  },
});
export const FlightContactModal = ({ onClose }) => {
  const classes = contactModalStyles();

  // const { contact_information } = useSelector((state) => ({
  //   contact_information: _.get(
  //     state.WebsiteMetadata,
  //     "metadata.contact_information"
  //   ),
  // }));
  // const { phone, email } = contact_information || {};

  return (
    <div className={classes.overlay}>
      <div className={classes.FlightContactModal}>
        <div className={classes.title}>Under construction</div>
        {/* <span>Please contact us via email.</span> */}
        {/* {/\* <div className={classes.message}>Comming Soon!</div> *\/} */}
        {/* <ContactBtns email={email} phone={phone} /> */}
        <br />
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  );
};
FlightContactModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export const CruiseContactModal = ({ onClose }) => {
  const classes = contactModalStyles();

  // const { contact_information } = useSelector((state) => ({
  //   contact_information: _.get(
  //     state.WebsiteMetadata,
  //     "metadata.contact_information"
  //   ),
  // }));
  // const { phone, email } = contact_information || {};

  return (
    <div className={classes.overlay}>
      <div className={classes.FlightContactModal}>
        <span className={classes.title}>Under construction</span>
        {/* <span>Please contact us via email.</span> */}
        {/* {/\* <div className={classes.message}>Coming Soon!</div> *\/} */}
        {/* <ContactBtns email={email} phone={phone} /> */}
        <br />
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  );
};
CruiseContactModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export const CarRentalContactModal = ({ onClose }) => {
  const classes = contactModalStyles();

  // const { contact_information } = useSelector((state) => ({
  //   contact_information: _.get(
  //     state.WebsiteMetadata,
  //     "metadata.contact_information"
  //   ),
  // }));
  // const { phone, email } = contact_information || {};

  return (
    <div className={classes.overlay}>
      <div className={classes.FlightContactModal}>
        <div className={classes.title}>Under construction</div>
        {/* <span>Please contact us via email.</span> */}
        {/* <div className={classes.message}>Coming Soon!</div> */}
        {/* <ContactBtns email={email} phone={phone} /> */}
        <br />
        <Button onClick={onClose}>Close</Button>
      </div>
    </div>
  );
};
CarRentalContactModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
